/**
 * 收款单弹框
 */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CollectionModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Form, Input, Select, InputNumber, DatePicker, Button } from 'antd';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import { XInfoLabel } from '@/components/xqxc_ui';
import { priceUppercase, regFenToYuan, regYuanToFen } from '@/util/money';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { fullCount } from 'ts-toolset/dist/common/callback';
import { BusinessType } from '../types';

const layout = {
    labelCol: {
        span: 4
    }
};

const itemCol = { span: 8 };
const inputStyle = { width: '100%' };
const inputValid = [{ required: true, message: '请输入' }];
const selectValid = [{ required: true, message: '请选择' }];

const InfoModal = (props) => {

    const editing = useRef(props.data.id !== undefined);
    const inited = useRef(false);

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const [paymentUnitList, setPaymentUnitList] = useState([]);
    const [paymentTypeList, setPaymentTypeList] = useState([]);
    const [businessTypeList, setBusinessTypeList] = useState([]);
    const [paymentUnit, setPaymentUnit] = useState({ money: '-', moneyUp: '-' });
    const [payTotalAmountUp, setPayTotalAmountUp] = useState();

    function _handleOk() {
        let url = editing.current
            ? '/?cmd=com.xqxc.api.pig.mis.settle.SettleReceiptApiMisService.updateReceipt'
            : '/?cmd=com.xqxc.api.pig.mis.settle.SettleReceiptApiMisService.newReceipt';

        // let money = parseFloat(paymentUnit.money);
        // if (!money) {
        //     return message.warning('余额不足');
        // }

        form.validateFields().then(({ annexUrl, receiveDate, payTotalAmount, content, payerUserName, ...fields }) => {
            setConfirmLoading(true);

            let convert = {
                annexUrl: annexUrl && annexUrl.map(v => v.url).join(','),
                receiveDate: receiveDate && receiveDate.format('YYYY-MM-DD 00:00:00'),
                payTotalAmount: regYuanToFen(payTotalAmount)
            };

            http(url, {
                receiptId: props.data.id,
                payContent: content,
                payUser: payerUserName,
                ...fields,
                ...convert
            }, 'POST').then(() => {
                message.success('操作成功');
                setConfirmLoading(false);
                props.closeMode && props.closeMode(true);
            }).catch((e = {}) => {
                message.error(e.message || '提交异常');
                setConfirmLoading(false);
            });
        });

    }

    function _handleCancel() {
        props.closeMode && props.closeMode();
    }

    function onFile(e) {
        let result = Array.isArray(e) ? e : (e && e.fileList);
        return result.length > 0 ? [result.pop()] : result;
    };

    function onPayTotalBlur(e) {
        let val = +e.target.value || 1;
        onPayTotalAmountChange(val)
    }

    function onPayTotalAmountChange(value) {
        let valid = true;
        if (value > 999999.99) {
            valid = false;
            form.setFieldsValue({ payTotalAmount: 999999.99 });
        }
        if (value < 1) {
            valid = false;
            form.setFieldsValue({ payTotalAmount: 1 });
        }

        if (valid) {
            let val = '';
            if (value !== '') {
                val = priceUppercase(value);
            }
            setPayTotalAmountUp(val);
        }
    }

    function onPayCompanyChange(userId, opts) {
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.getEnterpriseInfo', { id: opts.id }).then((res = {}) => {
            if (res.errCode === 0) {
                let info = res.result.enterpriseBasicInfoResp;
                let money = regFenToYuan(res.result.accountBalance);
                let moneyUp = priceUppercase(money);
                setPaymentUnit({
                    bank: info.epOpenBank,
                    account: info.epBankAccount,
                    address: info.epRegisterAddr,
                    name: res.result.realName,
                    tel: res.result.tel,
                    money,
                    moneyUp
                });
                // if (editing.current && inited.current) {
                //     form.setFieldsValue({ payTotalAmount: money });
                //     setPayTotalAmountUp(moneyUp);
                // }
                inited.current = true;
            }
        })
    }

    useEffect(() => {

        // 详情接口 和 下拉列表 都请求完后才来初始化企业信息
        let callback = fullCount(2, (params, all) => {
            const [userId, list] = Array.isArray(all[0]) ? all.reverse() : all;
            let unit = list.find(v => v.value == userId);
            onPayCompanyChange(userId, unit);
        });

        if (props.data.id !== undefined) {
            http('/?cmd=com.xqxc.api.pig.mis.settle.SettleReceiptApiMisService.queryReceiptDetail', { receiptId: props.data.id }).then(res => {
                let covert = {
                    annexUrl: generateFileList(res.result.annexUrl),
                    receiveDate: moment(res.result.receiveDate),
                    payTotalAmount: regFenToYuan(res.result.payTotalAmount)
                };
                form.setFieldsValue({ ...res.result, ...covert });
                setPayTotalAmountUp(priceUppercase(covert.payTotalAmount));
                callback(res.result.payCompanyId);
            }).catch(e => message.error(e.errDesc));
        }

        http('/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.listAllEnterpriseName', {}).then(res => {
            if (res.errCode === 0) {
                let arr = (res.result || []).map(v => ({ value: v.userId, label: v.epName, id: v.id }));
                setPaymentUnitList(arr);
                callback(arr);
            }
        })

        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', { enumName: 'SettleReceiptPayMethodEnum' }).then(res => {
            if (res.errCode === 0) {
                let arr = (res.result || []).map(v => ({ value: v.code, label: v.value }));
                setPaymentTypeList(arr);
            }
        })

        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', { enumName: 'SettleReceiptBusinessEnum' }).then(res => {
            if (res.errCode === 0) {
                let arr = (res.result || []).map(v => ({ value: v.code, label: v.value }));
                setBusinessTypeList(arr);
            }
        })
    }, []);

    return (
        <Modal
            width={700}
            centered
            title={props.title}
            visible={props.visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <Form {...layout} className={styles.container} form={form} labelAlign='right'>
                <Form.Item
                    name='payCompanyId'
                    label='交款单位名称'
                    rules={selectValid}
                    extra={
                        <div className={styles.unitInfo}>
                            <div className={styles.fields}>
                                <XInfoLabel label='开户行：' value={paymentUnit.bank} />
                                <XInfoLabel label='对公账户：' value={paymentUnit.account} />
                            </div>
                            <div className={styles.fields}>
                                <XInfoLabel label='地址：' value={paymentUnit.address} />
                                <XInfoLabel label='姓名/电话：' value={`${paymentUnit.name || '-'} / ${paymentUnit.tel || '-'}`} />
                            </div>
                        </div>
                    }
                >
                    <Select
                        showSearch
                        placeholder='请选择'
                        optionFilterProp='label'
                        options={paymentUnitList}
                        onChange={onPayCompanyChange}
                        filterOption={(input, option) => (option.label || '').toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    />
                </Form.Item>
                <Form.Item label='帐户余额'>
                    <span>{paymentUnit.money}（{paymentUnit.moneyUp}）</span>
                </Form.Item>
                <div className={styles.colItem}>
                    <Form.Item
                        name='payTotalAmount'
                        label='交款总额'
                        labelCol={itemCol}
                        extra={payTotalAmountUp && <div className={styles.payTotalAmount}>{payTotalAmountUp}</div>}
                        rules={inputValid}
                    >
                        <InputNumber style={inputStyle} placeholder='请输入' onChange={onPayTotalAmountChange} onBlur={onPayTotalBlur} max={999999.99} min={1} precision={2} />
                    </Form.Item>
                    <Form.Item
                        label='收款日期'
                        name='receiveDate'
                        labelCol={itemCol}
                        initialValue={moment()}
                    >
                        <DatePicker placeholder='请选择' showTime={false} style={inputStyle} />
                    </Form.Item>
                </div>
                <div className={styles.colItem}>
                    <Form.Item
                        name='businessType'
                        label='业务类型'
                        labelCol={itemCol}
                        rules={selectValid}
                        initialValue={BusinessType.CORPORATE_MEMBER_RECHARGE}
                    >
                        <Select placeholder='请选择' options={businessTypeList} style={{ width: 200 }}></Select>
                    </Form.Item>
                    <Form.Item
                        name='payMethod'
                        label='交款方式'
                        labelCol={itemCol}
                        rules={selectValid}
                    >
                        <Select placeholder='请选择' options={paymentTypeList} style={{ width: 200 }}></Select>
                    </Form.Item>
                </div>
                <Form.Item
                    name='content'
                    label='交款内容'
                    rules={inputValid}
                >
                    <Input.TextArea placeholder='请输入' maxLength={300} rows={4} showCount />
                </Form.Item>
                <Form.Item
                    name='payerUserName'
                    label='缴款人'
                    rules={inputValid}
                >
                    <Input placeholder='请输入' maxLength={50} />
                </Form.Item>
                <Form.Item
                    label='上传附件'
                    name='annexUrl'
                    valuePropName='fileList'
                    getValueFromEvent={onFile}
                    extra='支持扩展名：.doc .docx .pdf .jpg .png'
                    style={{ height: 80 }}
                >
                    <CusotmUpload
                        accept='.doc, .docx, .pdf, .jpg, .png'
                        removeError
                        qiniuUploadProps={{ uploadType: 'image' }}
                        beforeUpload={file => {
                            let type = (file.name || '').replace(/.+\./g, '.');
                            const isType = ['.doc', '.docx', '.pdf', '.jpg', '.png'];
                            const isGt3M = file.size / 1024 / 1024 > 3;
                            if (!isType.includes(type)) {
                                message.warn('只能上传 .doc, .docx, .pdf, .jpg, .png 格式的文件!');
                                file.status = 'error';
                                return false;
                            }
                            if (isGt3M) {
                                message.warn('图片必须小于 3M!');
                                file.status = 'error';
                                return false;
                            }
                        }}
                    >
                        <Button icon={<UploadOutlined />} style={{ marginBottom: 5 }}>上传文件</Button>
                    </CusotmUpload>
                </Form.Item>
            </Form>
        </Modal>
    );

}

InfoModal.propTypes = {
    data: PropTypes.any, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

export default InfoModal;